export enum FlightType {
  Deal = 'EMPTY_LEG',
  Shuttle = 'JET_SHUTTLE',
  Charter = 'JET_CHARTER'
}
